import { API } from './resources'

export default {
  get: (formId, questionnaireId) => {
    return API.get('/forms/questions', { params: { formId: formId, questionnaireId: questionnaireId, pageSize: 25 } })
  },
  saveUserFormQuestionAnswers: (data) => {
    return API.post('/forms/answers', data)
  },
  getQuestionnaireForm: (data) => {
    return API.post('/forms/questionnaire', data)
  }
}
